import React from 'react';
import { certificaciones } from '../data/viajes';
import './CertStrip.css';

export default function CertStrip() {
  const loop = certificaciones.concat(certificaciones);
  return (
    <section className="certstrip" aria-label="Certificaciones">
      <div className="wrap certstrip__in">
        <span className="eyebrow">Certificada por</span>
        <div className="certstrip__mask">
          <div className="certstrip__track">
            {loop.map((c, k) => <span key={k} aria-hidden={k >= certificaciones.length}>{c.nombre}<i /></span>)}
          </div>
        </div>
      </div>
    </section>
  );
}
